<template>
  <div style="margin: 0 auo">
    <div style="color: #3d4d6b">
      <ul class="invite-content invite-content-Merchant">
        <li style="flex: 0 0 10px"></li>
        <li style="text-align: center; padding: 15px">
          {{ $t('invitePage.inputInviteTargetEmail') }}
        </li>
        <li style="text-align: center">
          <a-input
            v-model:value="userEmailInput"
            :placeholder="$t('invitePage.inputInviteTargetEmail')"
            style="border: 0; width: 97%"
          >
          </a-input>
        </li>
        <!-- style="display:flex;padding-top:15px;justify-content: space-around;" -->
        <!-- style="border: 0; width: 47%" -->
        <li class="userNameBox">
          <a-input
            v-model:value="userFirstName"
            :placeholder="$t('invitePage.firstName')"
          >
          </a-input>
          <!-- style="border: 0; width: 47%"  userNameInput-->
          <a-input
            v-model:value="userLastName"
            :placeholder="$t('invitePage.lastName')"
          >
          </a-input>
        </li>
        <!-- style="display: flex;padding-top: 15px;justify-content: space-around;" faxInputBox-->
        <li class="faxInputBox">
          <!-- style="display: flex; align-items: center; justify-content: center" faxInputBoxDiv-->
          <div class="faxInputBoxDiv">
            <!-- style="width: 71px; margin-right: 5px; font-size: 12px"-->
            <a-select
              v-model:value="faxCountryCode"
              default-value="+852"
              class="contryCodeSelect"
            >
              <a-select-option v-for="item in CountryCodeList" :key="item.code"
                >{{ item.code }}
              </a-select-option></a-select
            >
            <!-- style="border: 0; width: 54%" -->
            <a-input
              v-model:value="fax"
              :placeholder="$t('invitePage.fax')"
              class="faxInput"
            ></a-input>
          </div>
          <!-- style="display: flex; align-items: center; justify-content: center" -->
          <div class="faxInputBoxDiv">
            <!-- style="width: 71px; margin-right: 5px; font-size: 12px" -->
            <a-select
              v-model:value="phoneCountryCode"
              default-value="+852"
              class="contryCodeSelect"
            >
              <a-select-option
                v-for="item in CountryCodeList"
                :key="item.code"
                >{{ item.code }}</a-select-option
              ></a-select
            >
            <!-- style="border: 0; width: 54%" -->
            <a-input
              v-model:value="phoneNumber"
              :placeholder="$t('invitePage.phone')"
              class="faxInput"
            ></a-input>
          </div>
        </li>

        <!--  style=" display: flex; align-items: center; padding-top: 15px;  padding-left: 6px;"  mobileInputBox-->
        <li class="mobileInputBox">
          <!-- style="display: flex; align-items: center"-->
          <div class="mobileInputBoxDiv">
            <!-- style="width: 71px; margin-right: 5px; font-size: 12px" -->
            <a-select
              v-model:value="mobileCountryCode"
              default-value="+852"
              class="contryCodeSelect"
            >
              <a-select-option v-for="item in CountryCodeList" :key="item.code"
                >{{ item.code }}
              </a-select-option>
            </a-select>
            <!-- style="border: 0; width: 41%"  mobileInput -->
            <a-input
              v-model:value="mobileNumber"
              :placeholder="$t('invitePage.mobile')"
              class="mobileInput"
            ></a-input>
          </div>
        </li>
        <li style="flex: 1"></li>
      </ul>
    </div>
    <div style="text-align: center; padding-top: 10px">
      {{ $t('invitePage.restInvitationQuota') }} {{ InvitationQuota }}
    </div>
    <div style="text-align: center; padding-top: 20px">
      <a-button
        :disabled="isdisabled"
        :loading="loading"
        @click="invite"
        type="primary"
        style="height: 38px; background: #2ca70e; border-color: #2ca70e"
        >{{ $t('invitePage.invite') }}</a-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'InviteMerchant',
  data() {
    return {
      isdisabled: false,
      userFirstName: '',
      userLastName: '',
      userEmailInput: '',
      InvitationQuota: '',
      loading: false,
      CountryCodeList: '',
      faxCountryCode: '+852',
      fax: '',
      mobileCountryCode: '+852',
      mobileNumber: '',
      phoneCountryCode: '+852',
      phoneNumber: ''
    };
  },
  methods: {
    invite() {
      this.$emit('invite', {
        name: 'InviteMerchant',
        email: this.userEmailInput,
        firstName: this.userFirstName,
        lastName: this.userLastName,
        faxCountryCode: this.faxCountryCode,
        fax: this.fax,
        mobileCountryCode: this.mobileCountryCode,
        mobileNumber: this.mobileNumber,
        phoneCountryCode: this.phoneCountryCode,
        phoneNumber: this.phoneNumber
      });
    }
  },
  created() {
    let t1 = this.$store.getters.get_CountryCode_cache;
    this.CountryCodeList = t1;
  }
};
</script>

<style scoped>
.invite-content {
  background-color: #c6cbd1;
  min-height: 350px;
  display: flex;
  flex-flow: column;
}
.invite-content-Merchant {
  border-radius: 0px 8px 8px 8px;
}
input::-ms-input-placeholder {
  text-align: center;
}
input::-webkit-input-placeholder {
  text-align: center;
}

.userNameBox {
  display: flex;
  padding-top: 15px;
  justify-content: space-around;
}
.userNameBox > input {
  border: 0;
  width: 47%;
}
.faxInputBox {
  display: flex;
  padding-top: 15px;
  justify-content: space-around;
}
.faxInputBoxDiv {
  display: flex;
  align-items: center;
  justify-content: center;
}
.contryCodeSelect {
  width: 71px;
  margin-right: 5px;
  font-size: 12px;
}
.faxInput {
  border: 0;
  width: 54%;
}
.mobileInputBox {
  display: flex;
  align-items: center;
  padding-top: 15px;
  padding-left: 6px;
}
.mobileInputBoxDiv {
  display: flex;
  align-items: center;
}
.mobileInput {
  border: 0;
  width: 41%;
}

@media (max-width: 420px) {
  .userNameBox {
    flex-direction: column;
    align-items: center;
    margin-top: 5px;
    padding-top: 0px;
  }
  .userNameBox > input {
    width: 97%;
    margin: 5px auto;
  }
  .faxInputBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0px;
  }
  .faxInputBoxDiv {
    width: 97%;
    margin-top:5px;
    margin-bottom: 5px;
  }
  .contryCodeSelect {
    width: 30%;
  }
  .faxInput {
    width: 68%;
  }

  .mobileInputBox {
    flex-direction: column;
    margin-top: 5px;
    padding-top: 0px;
  }
  .mobileInputBoxDiv {
    margin-bottom: 5px;
    width: 100%;
    /* justify-content: center; */
  }
  .mobileInput {
    width: 67%;
  }
}
</style>
